module.exports = __webpack_public_path__ + "static/media/55831609_2519305598144616_441807128072552448_o.ef670a45.jpg";